import React from 'react';
import {ToggleButton, ToggleButtonGroup} from '@mui/material';
import {BAR_SORT_MODES} from './barSort';

/* "Group order · Highest first · Lowest first" — the sort control of a bar list.

     const [sortMode, setSortMode] = useState('group');
     <SortToggle value={sortMode} onChange={setSortMode}/>
     …sortBars(GROUPS, sortMode)… */
const NAVY = '#052F44';

export const SortToggle = ({value = 'group', onChange, modes = BAR_SORT_MODES, size = 'small', sx}) => (
    <ToggleButtonGroup
        exclusive
        size={size}
        value={value}
        onChange={(_, v) => { if (v) onChange(v); }}
        aria-label="Sort bars"
        sx={{
            flexShrink: 0,
            '& .MuiToggleButton-root': {
                textTransform: 'none', fontSize: '12px', fontWeight: 600, lineHeight: 1.2, px: 1.25, py: 0.5,
                color: '#6A7282', borderColor: 'var(--brand-border, #E5E7EB)',
            },
            '& .MuiToggleButton-root.Mui-selected': {color: NAVY, backgroundColor: 'rgba(5, 47, 68, 0.08)'},
            '& .MuiToggleButton-root.Mui-selected:hover': {backgroundColor: 'rgba(5, 47, 68, 0.12)'},
            ...sx,
        }}
    >
        {modes.map((m) => (
            <ToggleButton key={m.value} value={m.value} aria-label={m.label}>{m.label}</ToggleButton>
        ))}
    </ToggleButtonGroup>
);

export default SortToggle;
